import React from 'react';
import { Info, AlertTriangle, XCircle } from 'lucide-react';
import { cn } from '@/lib/utils';

interface NewsStripProps {
  message: string;
  type?: 'info' | 'warning';
  onClose?: () => void;
  className?: string;
}

const NewsStrip: React.FC<NewsStripProps> = ({ message, type = 'info', onClose, className }) => {
  const baseClasses = "p-3 rounded-lg flex items-center gap-3 text-sm font-medium";
  
  const typeClasses = {
    info: "bg-blue-900/30 text-blue-300 border border-blue-700",
    warning: "bg-yellow-900/30 text-yellow-300 border border-yellow-700",
  };

  const icon = type === 'warning' ? <AlertTriangle size={20} /> : <Info size={20} />;

  return (
    <div className={cn(baseClasses, typeClasses[type], className)}>
      {icon}
      <span className="flex-grow">{message}</span>
      {onClose && (
        <button 
          onClick={onClose} 
          className="text-current hover:text-white transition-colors"
          aria-label="Bezárás"
        >
          <XCircle size={18} />
        </button>
      )}
    </div>
  );
};

export default NewsStrip;